<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()" [onyxAutoFocus]="mode()">
    @let controls = form().controls;
    <onyx-text-field
      [formControl]="controls.firstName"
      label="labels.firstName"
      textTransform="titlecase"
      [size]="32"
    ></onyx-text-field>

    <onyx-text-field
      [formControl]="controls.lastName"
      label="labels.lastName"
      textTransform="titlecase"
      [size]="32"
    ></onyx-text-field>

    <onyx-text-field
      [formControl]="controls.peselNumber"
      label="labels.peselNumber"
      [size]="32"
    ></onyx-text-field>

    <onyx-datepicker
      [formControl]="controls.birthDate"
      label="labels.birthDate"
      [yearsRange]="{ past: 100, future: 0 }"
      [size]="32"
    ></onyx-datepicker>

    <div class="private-phone">
      <onyx-phone-number-input
        [formControl]="controls.privatePhone"
        label="labels.privatePhone"
        [hint]="`${I18N}.privatePhoneHint`"
        [size]="32"
        [showErrors]="!phoneNumberConflict()"
      ></onyx-phone-number-input>

      @if (phoneNumberConflict(); as conflict) {
        <div class="phone-conflict f-body-xs f-medium f-danger">
          <onyx-icon name="error-filled" [size]="12"></onyx-icon>

          @switch (conflict.type) {
            @case ('local') {
              <span>
                {{
                  'drivers.driverForm.uniqueErrors.privatePhone'
                    | translate: { privatePhone: conflict.phoneNumber }
                }}
              </span>

              <onyx-link
                color="blue"
                font="f-body-xs f-medium"
                (click)="showDriver(conflict.driverUuid)"
              >
                {{ 'labels.show' | translate }}
              </onyx-link>
            }
            @case ('global') {
              <div class="messages">
                <span>
                  {{ `${I18N}.globalConflictMessage` | translate }}
                </span>
                <span class="f-muted">
                  {{
                    `${I18N}.globalConflictDescription` | translate: conflict
                  }}
                </span>
              </div>

              <onyx-link
                color="blue"
                font="f-body-xs f-medium"
                (click)="contactSupport(conflict.phoneNumber)"
              >
                {{ 'labels.contact' | translate }}
              </onyx-link>
            }
          }
        </div>
      }
    </div>

    <onyx-phone-number-input
      [formControl]="controls.workPhone"
      label="labels.workPhone"
      [size]="32"
    ></onyx-phone-number-input>

    <onyx-text-field
      [formControl]="controls.privateEmail"
      label="labels.privateEmail"
      textTransform="lowercase"
      [size]="32"
    ></onyx-text-field>

    <onyx-dropdown
      [formControl]="controls.nationality"
      label="labels.nationality"
      [options]="countries$ | async"
      [search]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-address-input
      [formControl]="controls.homeAddress"
      label="labels.homeAddress"
      [showApartment]="true"
      apartmentWidth="calc(110/640 * 100%)"
      [gap]="16"
      [size]="32"
    ></onyx-address-input>

    <onyx-form-group [controls]="controls.assignedBase">
      <onyx-dropdown
        [formControl]="controls.assignedBase"
        label="labels.base"
        [link]="baseDropdownActions.link()"
        [options]="BASES_SOURCE"
        [optional]="true"
        [showAddOption]="baseDropdownActions.hasAdd()"
        [showErrors]="false"
        [size]="32"
        (addOption)="baseDropdownActions.add()"
      ></onyx-dropdown>

      <onyx-suggestions
        [control]="controls.assignedBase"
        [suggestions]="baseSuggestions$ | async"
      ></onyx-suggestions>
    </onyx-form-group>
  </form>
</onyx-section>
